import React from "react";
import { Link } from "react-router-dom";

import "./styles.css";
import useAuth from "../../Hooks/useAuth";

export default function NotFoundPage() {
  const auth = useAuth();

  return (
    <div id="lostPage" className="pt-5 page-content">
      <div className="contentBox text-center mx-lg-5 mx-3 mt-5 ">
        <div className="col-12">
          <ion-icon
            name="hammer-outline"
            size="large"
            className="hammer"
            style={{ color: "white" }}
          ></ion-icon>
        </div>
        <div className="header404Txt white">
          <b>404</b>
        </div>
        <h2 className="white">UH OH! You`re Lost!</h2>
        <div className="pt-3 pb-5">
          <h5 className="px-5 white noBold">
            The page you are looking for does not exist. How you got here is a
            mystery. But you can click the button below to go back to the{" "}
            {auth.isLogin ? "Portal" : "Login"} Page.
          </h5>
        </div>
        {auth.isLogin ? (
          <Link className="button col-6" to="/">
            <b>Portal Page</b>
          </Link>
        ) : (
          <Link className="button col-6" to="/login">
            <b>Login</b>
          </Link>
        )}
      </div>
    </div>
  );
}
